module.exports = __webpack_public_path__ + "static/media/2020-10-16-01.45563563.jpg";